import styled from "styled-components";

export const StoreLocatorWrapper = styled.div`
  aspect-ratio: 4 / 4;
  position: relative;

  ${({ theme }) => theme.mediaQuery.xl(`
    aspect-ratio: 16 / 10;
  `)}
`

export const StoreLocatorCustomIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: ${({ theme }) => theme.rem(32)};
  }
`

export const StoreLocatorLegend = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(16)};
  margin-bottom: ${({ theme }) => theme.rem(32)};
  align-items: center;
  justify-content: center;

  ${({ theme }) => theme.mediaQuery.xl(`
    flex-direction: row;
  `)}
`

export const StoreLocatorLegendItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.rem(16)};
  align-items: center;
`

export const StoreLocatorHeading = styled.div`
  margin-bottom: ${({ theme }) => theme.rem(64)};
  display: flex;
  align-items: center;
  justify-content: center;
`